module.exports = __webpack_public_path__ + "img/sop2.54d5bc24.jpg";